import { FileText, FileImage, FileAudio } from 'lucide-react';
export { taskTypeOptionsByModule } from '@/lib/taskTypeOptions';

export const levels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

export const ALL_QUESTION_TYPE_VALUES = [
  'multiple-choice-single',
  'multiple-choice-multi',
  'true-false',
  'text-short',
  'text-long',
  'audio-recording',
  'fill-in-blank',
  'yes-no',
  'matching',
  'live-conversation',
] as const;

export type QuestionTypeValue = (typeof ALL_QUESTION_TYPE_VALUES)[number];

/** Admin UI selectable question types. */
export const questionTypes = [
  { value: 'multiple-choice-single', label: 'Multiple Choice (Single Answer)' },
  {
    value: 'multiple-choice-multi',
    label: 'Multiple Choice (Multiple Answers)',
  },
  { value: 'true-false', label: 'True/False' },
  { value: 'text-short', label: 'Text (Short Answer)' },
  { value: 'text-long', label: 'Text (Long Answer)' },
  { value: 'audio-recording', label: 'Audio Recording' },
  { value: 'fill-in-blank', label: 'Fill in the Blank' },
  { value: 'yes-no', label: 'Yes/No' },
  { value: 'matching', label: 'Matching' },
  { value: 'live-conversation', label: 'Live Conversation (AI-led dialogue)' },
];

export const modules = [
  { value: 'reading', label: 'Reading' },
  { value: 'listening', label: 'Listening' },
  { value: 'writing', label: 'Writing' },
  { value: 'speaking', label: 'Speaking' },
];

export const contextTypeConfig = {
  text: {
    badgeColor: 'bg-primary/10 text-primary',
    icon: FileText,
  },
  image: {
    badgeColor: 'bg-primary/10 text-primary',
    icon: FileImage,
  },
  audio: {
    badgeColor: 'bg-primary/10 text-primary',
    icon: FileAudio,
  },
} as const;
